export enum URLOpenType {
  SAME_PAGE = '_self',
  NEW_TAB = '_blank',
}
